import React, { useState, useRef, useEffect } from "react";

import { Input, Button, Checkbox, FormControlLabel, MenuItem, Select, Tooltip } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import kutil, { type PageInfo } from "@modules/kutil";
import commonCode, { type Code } from "@modules/common_code";
import valueFormatter from "@modules/value_formatter";

import router from "@user/router";

import "./rack_reorder.scoped.scss";

function RackReorder(_props: any) {

  return (
    <>
      {/* contents */}
      <div className="contents">
        {/* contents 상단 */}
        <div className="contents-top">
          {/* 타이틀 영역 */}
          <div className="title-area">
            {/* 타이틀 */}
            <p>자동창고 RACK 정리</p>
          </div>
          {/*// 타이틀 영역 */}
          {/* 버튼 영역 */}
          <div className="top-btn-area">
            <Button variant="outlined">조회</Button>
            <Button variant="outlined">엑셀다운</Button>
            <Button variant="contained">RACK 정리</Button>
          </div>
          {/*// 버튼 영역 */}
        </div>
        {/*// contents 상단 */}
        {/* 검색 */}
        <div className="srch-area">
          <div>
            <p>기준일자</p>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                format="YYYY.MM.DD"
              />
            </LocalizationProvider>
          </div>
          <p>
            <Tooltip title="초기화">
              <button className="icon-button form-reset">초기화</button>
            </Tooltip>
          </p>
        </div>
        {/*// 검색 */}
        {/* 그리드 상단 */}
        <div className="grid-top-area">
          <div>
            <p>상위</p>
            <Input />
            <p>개 /</p>
            <FormControlLabel control={<Checkbox defaultChecked size="small" />} label="전체" />
          </div>
          <Button variant="additional" size="small">선택</Button>
          <div className="workstation">
            <p>임시보관 작업대</p>
            <Select>
              <MenuItem value="">1-1</MenuItem>
            </Select>
          </div>
        </div>
        {/*// 그리드 상단 */}
        {/* RACK 정리 목록 */}
        <div className="grid-area">
          Grid
        </div>
        {/*// RACK 정리 목록 */}
      </div>
      {/*// contents */}
    </>
  );
}

export default React.memo(RackReorder);
